var _style, _ellipse, _path, _path2, _path3, _path4, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSleep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E98DBB;}\n\t.st1{fill:none;stroke:#070708;stroke-miterlimit:10;}\n\t.st2{fill:#0B0B0B;}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 22.34,
    cy: 25.28,
    rx: 13.92,
    ry: 14.34
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.08,36.06"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.86,29.3c0,0-4.78-10.25,5.83-16.43c0,0-5.97,12.78,8.16,17.48c2.41,0.64,4.31,0.23,7.81-0.82 c0,0-1.35,6.17-6.64,6.52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.79,32.91c0,0,3.99-5.83,8.3-1.4c0.82,1.17,1.17,2.1,1.17,2.1s-0.02,1.17,1.97,0.93 c0.94,0.35,3.04,0.93,2.11,3.84c-0.47,1.28-0.82,1.75-4.54,1.86s-10.83,0-10.83,0s-3.5-0.35-3.38-4.19c0.35-1.17,1.4-2.56,3.26-2.45 C17.53,33.96,19.12,34.66,18.79,32.91z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.68,33.15c0,0,1.05-1.28,2.39-1.28"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -1.3719 20.6277)",
    className: "st2",
    cx: 37.81,
    cy: 12.87,
    rx: 0.93,
    ry: 0.64
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6696 -0.7428 0.7428 0.6696 2.2521 30.8098)",
    className: "st2",
    cx: 35.75,
    cy: 12.87,
    rx: 0.64,
    ry: 0.93
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6696 -0.7428 0.7428 0.6696 1.4769 32.9993)",
    className: "st2",
    cx: 37.83,
    cy: 14.84,
    rx: 0.64,
    ry: 0.93
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -2.63 19.8644)",
    className: "st2",
    cx: 35.75,
    cy: 14.84,
    rx: 0.93,
    ry: 0.64
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 39.42,
    cy: 24,
    r: 0.66
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 41.04,
    cy: 24,
    r: 0.66
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 41.04,
    cy: 25.66,
    r: 0.66
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 39.42,
    cy: 25.66,
    r: 0.66
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 29.41,
    cy: 19.24,
    r: 0.66
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 31.03,
    cy: 19.24,
    r: 0.66
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 31.03,
    cy: 20.89,
    r: 0.66
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 29.41,
    cy: 20.89,
    r: 0.66
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleep);
export default __webpack_public_path__ + "static/media/Sleep.16026b4de6e5bd5ebf9eead65a44e334.svg";
export { ForwardRef as ReactComponent };